// src/data/NoticeData.ts

export interface Notice {
    id: number;
    title: string;
    content: string;
    date: string;
}

export const noticeList: Notice[] = [
    {
        id: 1,
        title: '[안내] 크릿(Creait) 공식 오픈 안내',
        content: `
안녕하세요, 창작자님!

크릿 대표 준이입니다.

2024년 10월 14일, '<span style="color: #e86531;">크릿</span>' 스토어가 공식 오픈되었습니다! 🎉

크릿은 '크리에이터 유닛'의 줄임말로, 창작자들이 자신의 독창적인 작품을 널리 알리고 판매할 수 있는 플랫폼입니다. 
우리는 다양한 분야의 작품들이 한곳에 모여 창작자와 소비자 간의 새로운 연결을 만들어가기를 기대하고 있습니다. 
<span style="color: #e86531;">크릿 스토어</span>에서는 모델링, 건축물, 엔티티, 픽셀, 스킨, 플러그인 등 다양한 창작물들을 만나보실 수 있으며, 각 창작자님의 개성과 열정이 담긴 소중한 작품들을 소개합니다.

<span style="color: #e86531;">크릿</span>의 핵심 목표는 창작자 여러분이 자신만의 독특한 세계를 더 많은 사람들과 나누고, 그 가치를 인정받을 수 있는 공간을 제공하는 것입니다. 저희는 창작자와 소비자 간의 소통을 원활하게 하고, 창작자 여러분이 보다 많은 기회를 얻을 수 있도록 다양한 지원 프로그램을 마련할 예정입니다.

앞으로도 <span style="color: #e86531;">크릿</span>은 지속적으로 플랫폼의 기능을 개선하고, 창작자분들의 목소리를 반영하여 더 나은 환경을 만들어가겠습니다. 여러분의 소중한 작품이 크릿을 통해 많은 사랑을 받을 수 있도록 함께 힘쓰겠습니다.

많은 관심과 참여 부탁드리며, <span style="color: #e86531;">크릿</span>과 함께 창작의 여정을 함께 하시기를 바랍니다.

감사합니다.

크릿 운영진 일동.
        `,
        date: '2024.09.13',
    },
    {
        id: 2,
        title: '[모집] CREAIT 파트너 프로그램 가이드 및 혜택',
        content: `
            <div style="font-family: Arial, sans-serif; line-height: 1.6; margin: 20px;">
                <h2 style="color: #e86531;">안녕하세요, 창작자님!</h2>
                <p>크릿(CREAIT)에서 더욱 풍성한 창작 환경을 제공하기 위해 <span style="color: #e86531;">CREAIT 파트너 프로그램</span>을 시작합니다.</p>
                <p>
                    파트너 프로그램은 창작자들이 플랫폼 내에서 더 큰 성장을 이루고, 추가적인 혜택을 누릴 수 있도록 마련된 제도입니다.
                    파트너로 선정된 크리에이터는 플랫폼의 핵심 일원이 되어 다양한 지원을 받으며, 더 넓은 고객층과 연결될 수 있는 기회를 얻게 됩니다.
                </p>

                <h1 style="color: #e86531;">파트너 선정 기준</h1>
                <h2>1. 콘텐츠 품질</h2>
                <ul>
                    <li><strong>독창성 및 차별화 요소:</strong> 창의적이고 독창적인 콘텐츠</li>
                    <li><strong>기능적 완성도:</strong> 기술적으로 완성도 높은 구현</li>
                    <li><strong>지속 가능성:</strong> 오랜 시간 동안 사용 가능한 콘텐츠</li>
                </ul>

                <h2>2. 판매 실적</h2>
                <ul>
                    <li><strong>꾸준한 판매 성과:</strong> 장기간에 걸친 안정적인 판매 실적</li>
                    <li><strong>재구매율 및 사용자 충성도:</strong> 높은 재구매율과 충성도</li>
                </ul>

                <h2>3. 커뮤니티 기여도</h2>
                <ul>
                    <li><strong>커뮤니티 활동 빈도:</strong> 활발한 커뮤니티 참여</li>
                    <li><strong>공동 프로젝트 및 협업:</strong> 다른 크리에이터와의 협업 경험</li>
                </ul>

                <h2>4. 업데이트 및 유지 관리</h2>
                <ul>
                    <li><strong>지속적인 콘텐츠 개선:</strong> 정기적인 업데이트 및 버그 수정</li>
                    <li><strong>장기적인 로드맵:</strong> 콘텐츠에 대한 장기 계획</li>
                </ul>

                <h2>5. 플랫폼 외부에서의 활동 및 영향력</h2>
                <ul>
                    <li><strong>외부 플랫폼에서의 콘텐츠 홍보:</strong> 소셜 미디어, 유튜브 등에서의 홍보</li>
                    <li><strong>콘텐츠의 외부 사용:</strong> 외부 플랫폼에서의 콘텐츠 인지도</li>
                </ul>

                <h2>6. 법적 및 윤리적 기준 준수</h2>
                <ul>
                    <li><strong>지적 재산권 보호:</strong> 타인의 지적 재산권 준수</li>
                    <li><strong>플랫폼 정책 준수:</strong> CREAIT 커뮤니티 가이드라인 준수</li>
                </ul>

                <h1 style="color: #e86531;">파트너 심사 절차</h1>
                <h2>1. 2차 평가: CREAIT 팀의 수동 심사</h2>
                <ul>
                    <li>콘텐츠 품질 심사</li>
                    <li>사용자 피드백 및 평점 분석</li>
                    <li>커뮤니티 활동 평가</li>
                </ul>

                <h2>2. 3차 심사: 최종 인터뷰 및 협의</h2>
                <ul>
                    <li>크리에이터 인터뷰</li>
                    <li>파트너 역할에 대한 논의</li>
                </ul>

                <h2>3. 최종 심사: 내부 평가 회의</h2>
                <ul>
                    <li>최종 결정</li>
                    <li>파트너 자격 부여</li>
                </ul>

                <h2>4. 파트너 계약 체결 및 혜택 적용</h2>
                <ul>
                    <li>파트너 계약 체결</li>
                    <li>혜택 활성화</li>
                </ul>

                <h1 style="color: #e86531;">파트너 혜택</h1>
                <h2>1. 스토어 내 우선 노출</h2>
                <ul>
                    <li>전략적 홍보</li>
                    <li>맞춤형 추천</li>
                </ul>

                <h2>2. 마케팅 및 홍보 지원</h2>
                <ul>
                    <li>종합 마케팅 캠페인</li>
                    <li>스페셜 이벤트</li>
                </ul>

                <h2>3. 수수료 혜택</h2>
                <ul>
                    <li>차별화된 수익 구조</li>
                    <li>추가 혜택 조건</li>
                </ul>

                <h2>4. 콘텐츠 업데이트 및 피드백 지원</h2>
                <ul>
                    <li>지속적인 품질 개선</li>
                    <li>전문가 상담 서비스</li>
                </ul>

                <h2>5. 전문 워크샵 및 네트워킹 기회</h2>
                <ul>
                    <li>전문가와의 만남</li>
                    <li>교육 프로그램</li>
                </ul>

                <h2>6. 특별 배지 및 파트너 인증</h2>
                <ul>
                    <li>브랜딩 강화</li>
                    <li>커뮤니티 내 인지도 향상</li>
                </ul>

                <h2>7. 기술 지원 및 우선 문의 처리</h2>
                <ul>
                    <li>신속한 문제 해결</li>
                    <li>전문 기술 상담</li>
                </ul>

                <p>파트너 프로그램에 관심이 있으신 분들은 아래 링크를 통해 지원해주시기 바랍니다.</p>
                <p>
                    🔗 <a href="https://cnitsstore.com/partner-apply" target="_blank" style="color: #e86531; text-decoration: underline;">파트너 지원하기</a>
                </p>
                <p>많은 참여와 관심 부탁드립니다!</p>
                <p>감사합니다.</p>
                <p>크릿 운영진 일동.</p>
            </div>
        `,
        date: '2024.10.04',
    },
];